package fr.frux.core.common.prefs

import fr.frux.core.common.storage.browserStorage

actual val persistentStorageAvailable: Boolean
    get() = browserStorage.persistent
